import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Sidebar from "../StudentDashboard/Sidebar";
import Header from "../StudentDashboard/Headers";
import { API_URL } from "../../config/api";
import AdminStudent from "./AdminStudent";

const Parent = () => {
  const [userData, setUserData] = useState(null);
  const [students, setStudents] = useState([]);
  const [totalStudents, setTotalStudents] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ name: "", email: "", phone: "" });

  const fetchStudents = useCallback(async (currentFilters) => {
    try {
      const token = localStorage.getItem("access_token");
      const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };

      const params = {};
      if (currentFilters.name) params.name = currentFilters.name;
      if (currentFilters.email) params.email = currentFilters.email;
      if (currentFilters.phone) params.phone = currentFilters.phone;

      const studentsRes = await axios.get(`${API_URL}/user/admin_students`, { headers, params });
      setStudents(studentsRes.data?.data?.students || []);
      setTotalStudents(studentsRes.data?.data?.total_students || 0);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  }, []);

  // Initial load
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) { setLoading(false); return; }

        const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };

        const currentUser = await axios.get(`${API_URL}/current_user`, { headers });
        const userId = currentUser.data?.user_id;
        if (!userId) { setLoading(false); return; }

        const [userDetailRes, studentsRes] = await Promise.all([
          axios.get(`${API_URL}/user/${userId}`, { headers }),
          axios.get(`${API_URL}/user/admin_students`, { headers }),
        ]);

        setUserData(userDetailRes.data?.data || userDetailRes.data || null);
        setStudents(studentsRes.data?.data?.students || []);
        setTotalStudents(studentsRes.data?.data?.total_students || 0);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  // Debounced filter fetch
  useEffect(() => {
    if (loading) return;

    const timer = setTimeout(() => {
      fetchStudents(filters);
    }, 400);

    return () => clearTimeout(timer);
  }, [filters]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto" />
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Unable to load user data. Please try again later.
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
      <div className="flex-shrink-0">
        <Header userData={userData} />
      </div>
      <div className="flex flex-1 overflow-hidden">
        <div className="w-56 bg-white border-r border-neutral-200 flex-shrink-0">
          <Sidebar />
        </div>
        <div className="flex-1 p-4 overflow-y-auto">
          <AdminStudent
            students={students}
            totalStudents={totalStudents}
            filters={filters}
            onFiltersChange={setFilters}
          />
        </div>
      </div>
    </div>
  );
};

export default Parent;